import {mapGetters, mapMutations} from "vuex";
//
import LanguageSwitcher from './components/language-switcher/index.vue';
import Social from './components/social/index.vue';
import MobileHeader from './components/mobile-navigation/index.vue'
import {camelCase} from 'lodash'
import {seo} from '@/mixins/seo'

const MainFooter = () => import('@/components/features/footer/index.vue');

export default {
    name: 'auth',
    data() {
        return {}
    },
    mixins: [seo],
    components: {
        LanguageSwitcher,
        Social,
        MobileHeader,
        MainFooter
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
            openMobileMenu: 'system/openMenu'
        }),
        setting() {
            return {
                support_email: 'info@genius.space',
            }
        }
    },
    created() {
        if (this.isAuthenticated) {
            this.$router.push({name: 'courses'});
        } else {
            if (localStorage.getItem('reloaded')) {
                localStorage.removeItem('reloaded');
            } else {
                localStorage.setItem('reloaded', '1');
                location.reload();
            }
        }

        this.seo.title = this.$t(camelCase(this.$route.name));
    },
    watch: {
        '$route'() {
            if (this.openMobileMenu) this.changeMobileMenu(false)
            this.seo.title = this.$t(camelCase(this.$router.currentRoute.name));
            this.$emit('updateHead')
        }
    },
    methods: {
        ...mapMutations({
            changeMobileMenu: 'system/CHANGE_MOBILE_MENU'
        }),
    }
}
